<template>
  <div>
    <!-- video-->
    <video
      v-if="content && content.stream_mode == 'video'"
      ref="videoPlayer"
      class="video-js vjs-16-9 vjs-big-play-centered"
      playsinline="true"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnded($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @statechanged="playerStateChanged($event)"
      @error="onPlayerError($event)"
      @retryplaylist="onPlayerRetryPlaylist($event)"
    ></video>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
const APP_BASE_URL = process.env.VUE_APP_BASE_URL;
import { mapState } from "vuex";
import videojs from "video.js";
import eventBus from "../plugins/vue-event-bus";
export default {
  name: "VideoJs",
  props: ["collectionId"],
  data() {
    return {
      player: null,
      youtubePattern:
        /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/,
      vimeoPattern:
        /(?:http:|https:|)\/\/(?:player.|www.)?vimeo\.com\/(?:video\/|embed\/|watch\?\S*v=|v\/)?(\d*)/,
      options: {
        controls: true,
        preload: "auto",
        sources: [
          {
            src: "",
            type: "application/x-mpegURL",
            withCredentials: true,
          },
        ],
      },
    };
  },
  created() {
    eventBus.$on("videoJsPlay", () => {
      try {
        if (this.player) this.player.play();
      } catch (e) {
        console.log("play Error", e);
      }
    });
    eventBus.$on("videoJsPause", () => {
      try {
        if (this.player) this.player.pause();
      } catch (e) {
        console.log("pause Error", e);
      }
    });
    eventBus.$on("videoJsReset", () => {
      try {
        console.log("reset");
        if (this.player) this.player.reset();
      } catch (e) {
        console.log("reset Error", e);
      }
    });
  },
  async mounted() {
    console.log("[VideoJs] mounted", Date.now());
    // 주소 설정
    let url;
    // const tokenString = this.user ? this.user.idToken : "";
    if (this.content && this.content.stream_mode == "video") {
      url = `${APP_BASE_URL}${
        this.content.stream_url
      }?_=${Date.now()}&t=${encodeURIComponent(
        this.content.stream_timelimit
      )}&c=${this.collectionId}`;
      this.options.sources[0].src = url;
      if (this.content.autoplay) {
        this.options.autoplay = true;
      }
      if (this.content.mute) {
        this.options.muted = true;
      }
      this.options.playbackRates = [0.8, 1, 1.2, 1.5, 1.7, 2];
    }

    this.player = videojs(
      this.$refs.videoPlayer,
      this.options,
      function onPlayerReady() {
        console.log("[VideoJsPlayer] onPlayerReady", Date.now());
      }
    );

    if (this.content && this.content.poster) {
      const posterUrl = APP_BASE_URL + "/" + this.content.poster;
      this.player.poster(posterUrl);
    }
  },
  computed: {
    ...mapState(["content", "gatePass", "user"]),
  },
  async beforeDestroy() {
    if (this.player) {
      // 부모창에서 iframe종료시 작동안 함.
      this.player.dispose();
      this.$store.commit("SET_VIDEO_PLAYING", false);
      await this.$store.dispatch("offline");
    }
  },
  methods: {
    onPlayerReady(evt) {
      console.log("Player ready", Date.now());
      evt.target.playVideo();
    },
    onPlayerStateChange(evt) {
      console.log("Player state changed", evt);
    },
    // listen event
    onPlayerPlay(player) {
      console.log("[VideoPlayer] player play!", player);
    },
    async onPlayerPause(player) {
      console.log("[VideoPlayer] player pause!", player);
      this.$store.commit("SET_VIDEO_PLAYING", false);
      await this.$store.dispatch("offline");
    },
    async onPlayerEnded(player) {
      console.log("[VideoPlayer] player ended!", player);
      this.$store.commit("SET_VIDEO_PLAYING", false);
      await this.$store.dispatch("offline");
    },
    onPlayerLoadeddata(player) {
      // console.log('player Loadeddata!', player)
    },
    onPlayerWaiting(player) {
      console.log("[VideoPlayer] player Waiting!", player);
    },
    async onPlayerPlaying(player) {
      console.log("[VideoPlayer] player Playing!", player);
      this.$store.commit("SET_VIDEO_PLAYING", true);
      // online 중임을 알림
      await this.$store.dispatch("online");
    },
    onPlayerTimeupdate(player) {
      // console.log('player Timeupdate!', player.currentTime())
    },
    onPlayerCanplay(player) {
      // console.log('player Canplay!', player)
    },
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    },
    // error
    onPlayerError(player) {
      console.log("[VideoPlayer] player error!", player);
    },
    // error
    onPlayerRetryPlaylist(player) {
      console.log("[VideoPlayer] player error!", player);
    },
    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
  },
};
</script>

<style src="@/assets/css/video-js.min.css"></style>
<style scoped>
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}
.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
